import type * as Types from '../../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import document from './updateCalendarEventPopMutation.gql';
import { CalendarEventFragmentDoc } from '../../fragments/calendar_events/CalendarEventFragment.generated';
import { SessionFragmentDoc } from '../../fragments/users/SessionFragment.generated';
import type * as ApolloReactCommon from '~/lazy_apollo/client';
import * as ApolloReactHooks from '~/lazy_apollo/client';
export type UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_calendarEvent_CalendarEvent_calendarEventRecurringExceptions_CalendarEventRecurringException = {
  __typename: 'CalendarEventRecurringException',
  id: number,
  exceptionAt: string
};

export type UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_calendarEvent_CalendarEvent_calendarEventSelectedLocations_CalendarEventSelectedLocation_location_RestaurantLocation = {
  __typename: 'RestaurantLocation',
  id: number,
  city: string,
  country: string,
  name: string,
  postalCode?: string | null,
  state?: string | null,
  streetAddress: string
};

export type UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_calendarEvent_CalendarEvent_calendarEventSelectedLocations_CalendarEventSelectedLocation = {
  __typename: 'CalendarEventSelectedLocation',
  id: number,
  isEnabled?: boolean | null,
  locationId?: number | null,
  location: UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_calendarEvent_CalendarEvent_calendarEventSelectedLocations_CalendarEventSelectedLocation_location_RestaurantLocation
};

export type UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_calendarEvent_CalendarEvent_pops_CalendarEventPop = {
  __typename: 'CalendarEventPop',
  id: number,
  calendarEventId?: number | null,
  popType?: string | null,
  sessionId?: string | null,
  userId?: number | null
};

export type UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_calendarEvent_CalendarEvent_selectedTags_CalendarEventSelectedTag_eventTag_EventTag = {
  __typename: 'EventTag',
  id: number,
  color: string,
  name?: string | null
};

export type UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_calendarEvent_CalendarEvent_selectedTags_CalendarEventSelectedTag = {
  __typename: 'CalendarEventSelectedTag',
  id: number,
  eventTagId?: number | null,
  eventTag?: UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_calendarEvent_CalendarEvent_selectedTags_CalendarEventSelectedTag_eventTag_EventTag | null
};

export type UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_calendarEvent_CalendarEvent_photoUploadedPhoto_UploadedPhoto_uiUploadable_UiUploadableBase = {
  __typename: 'UiUploadableBase',
  id: number,
  isMutable: boolean,
  showDeleteOption: boolean,
  showDownloadOption: boolean,
  showMoveOption: boolean,
  showCopyOption: boolean,
  showEditOption: boolean
};

export type UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_calendarEvent_CalendarEvent_photoUploadedPhoto_UploadedPhoto_uiUploadable_UiUploadableUploadedPhoto = {
  __typename: 'UiUploadableUploadedPhoto',
  id: number,
  isMutable: boolean,
  showDeleteOption: boolean,
  showDownloadOption: boolean,
  showMoveOption: boolean,
  showCopyOption: boolean,
  showEditOption: boolean
};

export type UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_calendarEvent_CalendarEvent_photoUploadedPhoto_UploadedPhoto_uiUploadable = UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_calendarEvent_CalendarEvent_photoUploadedPhoto_UploadedPhoto_uiUploadable_UiUploadableBase | UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_calendarEvent_CalendarEvent_photoUploadedPhoto_UploadedPhoto_uiUploadable_UiUploadableUploadedPhoto;

export type UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_calendarEvent_CalendarEvent_photoUploadedPhoto_UploadedPhoto = {
  __typename: 'UploadedPhoto',
  aimAvailable: boolean,
  altText?: string | null,
  bytes: number,
  category?: string | null,
  createdAt: string,
  folderPath?: string | null,
  format: string,
  fullUrl: string,
  height?: number | null,
  id: number,
  originalFilename: string,
  previewUrl: string,
  publicId?: string | null,
  rawUrl: string,
  restaurantId?: number | null,
  thumbnailUrl: string,
  updatedAt: string,
  uploaded?: boolean | null,
  uploadedFolderId?: number | null,
  url?: string | null,
  userId?: number | null,
  width?: number | null,
  uiUploadable: UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_calendarEvent_CalendarEvent_photoUploadedPhoto_UploadedPhoto_uiUploadable
};

export type UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_calendarEvent_CalendarEvent = {
  __typename: 'CalendarEvent',
  id: number,
  calendarEventPageUrl?: string | null,
  createdAt?: string | null,
  description?: string | null,
  dislikedItPopsCount?: number | null,
  endAt?: string | null,
  endTime?: number | null,
  eventTimeDescription?: string | null,
  externalLinkUrl?: string | null,
  externalLinkText?: string | null,
  hideStartEndDate: boolean,
  isAllDay?: boolean | null,
  isPastEvent: boolean,
  isMonday?: boolean | null,
  isTuesday?: boolean | null,
  isWednesday?: boolean | null,
  isThursday?: boolean | null,
  isFriday?: boolean | null,
  isSaturday?: boolean | null,
  isSunday?: boolean | null,
  isRecurring?: boolean | null,
  isSecret?: boolean | null,
  likedItPopsCount?: number | null,
  lovedItPopsCount?: number | null,
  name: string,
  photoAlt?: string | null,
  photoHeight?: number | null,
  photoUrl?: string | null,
  photoWidth?: number | null,
  popsCount?: number | null,
  publishGmb?: boolean | null,
  status?: string | null,
  startAt: string,
  startTime?: number | null,
  slug: string,
  thumbnailUrl?: string | null,
  wannaTryPopsCount?: number | null,
  recurringType: string,
  calendarEventRecurringExceptions: Array<UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_calendarEvent_CalendarEvent_calendarEventRecurringExceptions_CalendarEventRecurringException>,
  calendarEventSelectedLocations: Array<UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_calendarEvent_CalendarEvent_calendarEventSelectedLocations_CalendarEventSelectedLocation>,
  pops?: Array<UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_calendarEvent_CalendarEvent_pops_CalendarEventPop> | null,
  selectedTags: Array<UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_calendarEvent_CalendarEvent_selectedTags_CalendarEventSelectedTag>,
  photoUploadedPhoto?: UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_calendarEvent_CalendarEvent_photoUploadedPhoto_UploadedPhoto | null
};

export type UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_user_User = {
  __typename: 'User',
  id: number
};

export type UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_session_Session_calendarEventPops_CalendarEventPop = {
  __typename: 'CalendarEventPop',
  calendarEventId?: number | null,
  id: number,
  popType?: string | null
};

export type UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_session_Session_pops_Pop = {
  __typename: 'Pop',
  id: number,
  dishableId?: number | null,
  dishableType?: string | null,
  popType: string
};

export type UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_session_Session_reviews_Review = {
  __typename: 'Review',
  id: number,
  dishableId?: number | null,
  dishableType?: string | null,
  content?: string | null,
  locationId?: number | null
};

export type UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_session_Session_reviewUpvotes_ReviewUpvote = {
  __typename: 'ReviewUpvote',
  id: number,
  reviewId?: number | null
};

export type UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_session_Session_user_User_calendarEventPops_CalendarEventPop = {
  __typename: 'CalendarEventPop',
  id: number,
  calendarEventId?: number | null,
  popType?: string | null
};

export type UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_session_Session_user_User_pops_Pop = {
  __typename: 'Pop',
  id: number,
  dishableId?: number | null,
  dishableType?: string | null,
  popType: string
};

export type UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_session_Session_user_User_reviews_Review_restaurant_Restaurant = {
  __typename: 'Restaurant',
  id: number
};

export type UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_session_Session_user_User_reviews_Review = {
  __typename: 'Review',
  id: number,
  dishableId?: number | null,
  dishableType?: string | null,
  content?: string | null,
  locationId?: number | null,
  restaurant?: UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_session_Session_user_User_reviews_Review_restaurant_Restaurant | null
};

export type UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_session_Session_user_User_reviewUpvotes_ReviewUpvote = {
  __typename: 'ReviewUpvote',
  id: number,
  reviewId?: number | null
};

export type UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_session_Session_user_User_followers_Follower_favoriteLocation_RestaurantLocation = {
  __typename: 'RestaurantLocation',
  id: number,
  slug: string
};

export type UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_session_Session_user_User_followers_Follower = {
  __typename: 'Follower',
  id: number,
  isSmsUnsubscribed?: boolean | null,
  isUnsubscribed?: boolean | null,
  restaurantId: number,
  favoriteLocation?: UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_session_Session_user_User_followers_Follower_favoriteLocation_RestaurantLocation | null
};

export type UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_session_Session_user_User = {
  __typename: 'User',
  id: number,
  adminPaletteType?: string | null,
  currentSignInAt?: string | null,
  orderAudioType?: string | null,
  authyStatus?: string | null,
  avatarUrl?: string | null,
  birthDay?: number | null,
  birthMonth?: number | null,
  createdAt?: string | null,
  displayName: string,
  email?: string | null,
  firstName?: string | null,
  fullName?: string | null,
  isPendingPassword?: boolean | null,
  isRoot: boolean,
  isRootStaging: boolean,
  isSmsUnsubscribed?: boolean | null,
  isTextValidated: boolean,
  isUnsubscribed?: boolean | null,
  lastFourDigitsPhoneNumber?: string | null,
  lastName?: string | null,
  phone?: string | null,
  isMobilePhone?: boolean | null,
  thumbnailUrl?: string | null,
  userRole?: string | null,
  calendarEventPops?: Array<UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_session_Session_user_User_calendarEventPops_CalendarEventPop> | null,
  pops: Array<UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_session_Session_user_User_pops_Pop>,
  reviews: Array<UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_session_Session_user_User_reviews_Review>,
  reviewUpvotes: Array<UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_session_Session_user_User_reviewUpvotes_ReviewUpvote>,
  followers: Array<UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_session_Session_user_User_followers_Follower>
};

export type UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_session_Session = {
  __typename: 'Session',
  id: string,
  avatarUrl?: string | null,
  isAuthyRequired: boolean,
  isAuthyVerified: boolean,
  isSoftAuthenticated: boolean,
  calendarEventPops: Array<UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_session_Session_calendarEventPops_CalendarEventPop>,
  pops: Array<UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_session_Session_pops_Pop>,
  reviews: Array<UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_session_Session_reviews_Review>,
  reviewUpvotes: Array<UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_session_Session_reviewUpvotes_ReviewUpvote>,
  user?: UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_session_Session_user_User | null
};

export type UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop = {
  __typename: 'CalendarEventPop',
  id: number,
  calendarEventId?: number | null,
  popType?: string | null,
  calendarEvent?: UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_calendarEvent_CalendarEvent | null,
  user?: UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_user_User | null,
  session?: UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop_session_Session | null
};

export type UpdateCalendarEventPopMutation_Mutation = {
  __typename?: 'Mutation',
  updateCalendarEventPop: UpdateCalendarEventPopMutation_updateCalendarEventPop_CalendarEventPop
};


export type UpdateCalendarEventPopMutationVariables = Types.Exact<{
  calendarEventId: Types.Scalars['Int']['input'];
  popType?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type UpdateCalendarEventPopMutation = UpdateCalendarEventPopMutation_Mutation;


export const UpdateCalendarEventPopDocument = /*#__PURE__*/ document as unknown as DocumentNode<UpdateCalendarEventPopMutation, UpdateCalendarEventPopMutationVariables>;

export type UpdateCalendarEventPopMutationFn = ApolloReactCommon.MutationFunction<UpdateCalendarEventPopMutation, UpdateCalendarEventPopMutationVariables>;

/**
 * __useUpdateCalendarEventPopMutation__
 *
 * To run a mutation, you first call `useUpdateCalendarEventPopMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalendarEventPopMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param options options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCalendarEventPopMutation, { data, loading, error }] = useUpdateCalendarEventPopMutation({
 *   variables: {
 *      calendarEventId: // value for 'calendarEventId'
 *      popType: // value for 'popType'
 *   },
 * });
 */
export function useUpdateCalendarEventPopMutation(options?: ApolloReactHooks.MutationHookOptions<UpdateCalendarEventPopMutation, UpdateCalendarEventPopMutationVariables>) {
                return ApolloReactHooks.useMutation<UpdateCalendarEventPopMutation, UpdateCalendarEventPopMutationVariables>(UpdateCalendarEventPopDocument, options);
      }
export type UpdateCalendarEventPopMutationHookResult = ReturnType<typeof useUpdateCalendarEventPopMutation>;
export type UpdateCalendarEventPopMutationResult = ApolloReactCommon.MutationResult<UpdateCalendarEventPopMutation>;
export type UpdateCalendarEventPopMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCalendarEventPopMutation, UpdateCalendarEventPopMutationVariables>;